import { Form, Input, InputNumber } from "antd";
import React from "react";

const TotalThirdGender: React.FC = () => {
  return (
    <Form.Item
      name="thirdPopulation"
      label="Total Third Genders"
      rules={[
        {
          required: true,
          message: "Please enter the total third gender count",
        },
      ]}
    >
      <InputNumber
        changeOnWheel={false}
        controls={false}
        style={{ width: "100%" }}
      />
    </Form.Item>
  );
};

export default TotalThirdGender;
